import { useMemo, useState } from 'react';
import { DataGridPro, GridDensity, useGridApiRef } from '@mui/x-data-grid-pro';
import { useFetchCommissionsQuery } from '@api/Trinium/Endpoints/Settlements/slice';
import { GenericOverlay } from '@components/DataGrid/GenericNoRowsOverlay';
import BrandLinearProgress from '@/Infrastructure/Components/Loading/BrandLinearProgress';
import { CommissionsToolbar } from './Toolbar';
import { columns } from './types';
import { settlementsGridSx, settlementsRowHeight } from '../gridStyles';
import { IStatementTab } from '../types';

export default function CommissionsTab(props: IStatementTab) {
  const { data: commissions, isFetching } = useFetchCommissionsQuery({
    terminalNumber: props.terminalNumber,
    statementId: props.statementId
  });
  const apiRef = useGridApiRef();
  const [density, setDensity] = useState<GridDensity>('compact');

  const rows = useMemo(() => commissions ?? [], [commissions]);

  return (
    <DataGridPro
      apiRef={apiRef}
      columns={columns}
      rows={rows}
      loading={isFetching}
      density={density}
      onDensityChange={setDensity}
      rowHeight={settlementsRowHeight}
      showToolbar
      disableRowSelectionOnClick
      slots={{
        toolbar: CommissionsToolbar,
        loadingOverlay: BrandLinearProgress,
        noRowsOverlay: () => <GenericOverlay overlayText='No Commissions Found.' />
      }}
      sx={settlementsGridSx}
    />
  );
}
